/*
* Copyright (C) Regione Lombardia
*/
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { LayoutConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { LayoutDialogComponent } from './dialog/dialog.component';
import { LayoutFooterComponent } from './footer/footer.component';
import { LayoutHeaderComponent } from './header/header.component';
import { LayoutLoaderComponent } from './loader/loader.component';
import { LayoutAlertModalComponent } from './alert-modal/alert-modal.component';

@NgModule({
    imports: [
        BrowserModule,
        RouterModule,
        SharedModule,
        NgbDropdownModule,
    ],
    declarations: [
        LayoutFooterComponent,
        LayoutHeaderComponent,
        LayoutLoaderComponent,
        LayoutDialogComponent,
        LayoutAlertModalComponent,
        LayoutConfirmModalComponent
    ],
    exports: [
        LayoutFooterComponent,
        LayoutHeaderComponent,
        LayoutLoaderComponent,
        LayoutDialogComponent,
        LayoutAlertModalComponent,
        LayoutConfirmModalComponent
    ],
})
export class LayoutModule { }
